window.zfcgList = [
    { 
        content:'<p>公开招标适用条件：</p><p>1、公开招标限额标准：工程400万元；货物200万元；服务100万元；</p><p>2、集中采购目录以内的或者公开招标数额标准以上的货物、工程和服务。</p>',
        type:'2',
    },
    { 
        content:'<p>竞争性谈判适用条件：</p><p>1、招标后没有供应商投标或者没有合格标的或者重新招标未能成立的；</p><p>2、技术复杂或者性质特殊，不能确定详细规格或者具体要求的；</p><p>3、非采购人预见或拖延造成招标采购所需时间不能满足用户紧急需要的；</p><p>4、因艺术品采购、专利、专有技术或者服务的时间、数量事先不能确定等原因不能事先计算出价格总额的。</p>',
        type:'3',
    },
    { 
        content:'<p>竞争性磋商适用条件：</p><p>1、政府购买服务项目；</p><p>2、技术复杂或者性质特殊，不能确定详细规格或者具体要求的；</p><p>3、因艺术品采购、专利、专有技术或者服务的时间、数量事先不能确定等原因不能事先计算出价格总额的；</p><p>4、市场竞争不充分的科研项目，以及需要扶持的科技成果转化项目；</p><p>5、按照招标投标法及其实施条例必须进行招标的工程建设项目以外的工程建设项目。</p>',
        type:'6',
    },
    { 
        content:'<p>邀请招标适用条件：</p><p>1、具有特殊性，只能从有限范围的供应商处采购的；</p><p>2、采用公开招标方式的费用占政府采购项目总价值的比例过大的。</p>',
        type:'4',
    },
    { 
        content:'<p>询价采购适用条件：</p><p>1、采购的货物规格、标准统一；</p><p>2、货源充足且价格变化幅度比较小；</p><p>3、采购金额小，时间短。</p>',
        type:'5',
    },
    { 
        content:'<p>单一来源适用条件：</p><p>1、只能从唯一供应商处采购的，包括需要采用不可替代的专利或专有技术的;</p><p>2、必须保证原有采购项目一致性或功能配套的要求，需要继续从原供应商处采购的;</p><p>3、因抢险救灾等不可预见的紧急情况需要进行紧急采购的:</p><p>4、为了振兴国内制造业或提高重大装备国产化水平等国家政策需要直接采购的。</p>',
        type:'7',
    },
]